import styled from "styled-components";
import { InviteIcon } from "@assets";
import { Button as AntButton } from "antd";

export const InviteLinkContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
  padding: 0 16px;
`;

export const Heading = styled.div`
	border-radius: 10px;
	width: 100%;
`;

export const ChainIcon = styled(InviteIcon)`
  margin-top: 40px;
	width: 92px;
	height: 92px;
`;

export const InviteLinkTitle = styled.p`
  margin-top: 16px;
	color: #000000;
	font-weight: 400;
	font-size: 16px;
`;

export const CreateLinkButton = styled(AntButton)`
	color: #ffffff !important;
	font-weight: 400;
	font-size: 16px;

  height: 48px;
	width: 100% !important;
  border-radius: 16px !important;
  background: linear-gradient(90deg, #0060BE 0%, #04AEED 100%);

	&:hover {
    background: linear-gradient(90deg, #0060BE 0%, #04AEED 100%);
	  color: #ffffff !important;
	}
  @media screen and (max-width: 370px){
    width: 260px; 
  }
`;

export const TermsAndConditionsContainer = styled.div`
	min-height: calc(100vh - 400px - 70px);
	border-radius: 0px 0px 12px 12px;
  background: #DEEDFF;
	width: 100%;
  padding: 10px 0;
`;

export const InviteLinkTerms = styled.span`
	margin: 0px;
	padding: 0px;
	color: #000000;
	font-size: 13px;
	font-style: normal;
	font-weight: 400;
	line-height: 24px;
`;

export const CopyTitle = styled.p`
	margin-bottom: 10px;
	color: #0161BF;
	text-align: center;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
`;

export const CopyLink = styled.a`
	display: block;
	color: #6D7F8A;
	text-align: center;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 16.94px; /* 171.429% */
`;

export const TextWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

export const ChainTextWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-start;
  flex-direction: column;
	width: 260px;
	margin: 0 auto;
`;

export const ButtonWrapper = styled.div`
	display: flex;
	justify-content: center;
	margin: 15px 0;
`;

export const TopWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  border-radius: 12px 12px 0px 0px;
  background: #0161BF;
`;


export const Title = styled.p`
	color: #FFF;
	font-size: 14px;
	font-style: normal;
	font-weight: 600;
  padding: 0;
  margin: 10px 0;
`;